import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { SystemLogService } from '../core/service/system-log.service';
import { MessageHandlerService } from '../core/utility/message-handler.service';
import { SettingService } from '../core/service/setting.service';

@Component({
  standalone: false,
  selector: 'app-system-log',
  templateUrl: './system-log.component.html',
  styleUrls: ['./system-log.component.scss']
})
export class SystemLogComponent implements OnInit
{
  @ViewChild('logDiv') public logDiv: ElementRef;

  public currentSelectedLog = undefined;
  public logsData = [];
  public logTypes: Array<{ text: string; value: string; key: string }> = [];
  public logHeight = '100vh';
  public loading = true;

  constructor(
    private systemLogService: SystemLogService,
    private messageHandlerService: MessageHandlerService,
    private settingService: SettingService) { }

  public ngOnInit(): void
  {
    this.settingService.getCachedSessionSettings().subscribe({
      next: (sessionSetting) =>
      {
        const availableLogs = [];

        if (sessionSetting.serviceLogEnabled) 
        {
          availableLogs.push(this.systemLogService.logTypes.find(x => x.value === 'service'));
        }

        if (sessionSetting.workflowLogEnabled) 
        {
          availableLogs.push(this.systemLogService.logTypes.find(x => x.value === 'workflow'));
        }

        this.logTypes = availableLogs;
        if (this.logTypes && this.logTypes.length > 0) 
        {
          this.currentSelectedLog = this.logTypes[0];
          this.selectedLog(this.currentSelectedLog);
        }
      }
    });
  }

  public selectedLog(e: any): void 
  {
    this.loadLogs(e);
  }

  public onResized(): void
  {
    this.logHeight = `${window.innerHeight - 260}px`;
  }

  public formatLog(logItem: string): string
  {
    let formatted = '<div style="font-family:monospace">';
    if (logItem && logItem[4] === '-' && logItem[7] === '-') 
    {
      const arr = logItem.split(' ');
      for (let i = 0; i < arr.length; i++) 
      {
        if (i <= 1)   // Mark strong date and time
        {
          formatted += i === 0 ? '<strong>' : '';
          formatted += arr[i] + ' ';
          formatted += i === 1 ? '</strong>' : '';
        }
        else if (i === 3 && arr[i] === 'ERROR')
        {
          formatted += '<span style="color:#dc5d3f">' + arr[i] + '</span>';
        }
        else if (i === 3 && arr[i] === 'WARN')
        {
          formatted += '<span style="color:#e07a1a">' + arr[i] + '</span>';
        }
        else
        {
          formatted += arr[i].length === 0 ? ' ' : (arr[i][0] === ' ' ? arr[i] : ' ' + arr[i]);
        }
      }
    }
    else
    {
      formatted += logItem;
    }
    return formatted + '</div>';
  }

  public refresh(): void 
  {
    this.loadLogs(this.currentSelectedLog);
  }

  private loadLogs(selected: any): void
  {
    this.logsData = [];
    if (selected)  
    {
      this.loading = true;
      const functionName = `get${selected.value[0].toUpperCase() + selected.value.slice(1)}Log`;
      this.systemLogService[functionName]().subscribe({
        next: (data: any) =>
        {
          // Formatting content
          data.forEach((d: string) => { this.logsData.push(this.formatLog(d)); });
          this.loading = false;

          // Set focus to bottom
          setTimeout(() =>
          {
            if (this.logDiv)
            {
              this.logDiv.nativeElement.scrollTop = this.logDiv.nativeElement.scrollHeight;
            }
          });
        },
        error: (errorResponse: any) =>
        {
          this.messageHandlerService.displayError(errorResponse);
          this.loading = false;
        }
      });
    }
  }
}
